export default function productsListFunctionalities() {
  $(document).ready(function() {
    var buttonProducts = $('.products .list > button')
    var postProducts = $('.products .list ul li')
    var currentProducts = postProducts.filter(function() {
      return $(this).css('display') === 'block'
    }).length

    if (postProducts.length <= currentProducts) {
      buttonProducts.css({
        display: 'none',
        background: 'white',
        border: 'none',
      })
    }

    buttonProducts.on('click', function() {
      for (var e = currentProducts; e < currentProducts + 4; e++) {
        if (postProducts.eq(e)) {
          postProducts.eq(e).css('display', 'block')
        }
      }
      currentProducts += 4
      if (currentProducts >= postProducts.length) {
        buttonProducts.fadeOut()
      }
    })

    $('section.products .more-about-products .container-select-block ul.container-select-list li.option').click(function(e) {
      var brandSelect = $(this).attr('value')
      var allProducts = $('section.products .list > ul li')

      allProducts.show()

      setTimeout(() => {
        allProducts.each(function() {
          var brandProduct = $(this).attr('data-src-brand')
          if (brandSelect === brandProduct) {
            $(this).fadeIn()
          } else {
            $(this).fadeOut()
          }
        })
        buttonProducts.fadeOut()
      }, 200)
    })

    // caso seja por marca
    if ($('.in-brand').length) {
      $('section.products div.more-about-products div.container-select-block').hide()
      $('section.products div.list > button').hide()
      $('section.products div.list ul li').show()
    }

    // -----

    var postProductsBrand = $('.products-list .list ul li')
    var buttonProductsBrand = $('.products-list .list > button')
    var currentProductsBrand = postProductsBrand.filter(function() {
      return $(this).css('display') === 'block'
    }).length

    $('input[type="radio"][name="pet-filter"]').click(function() {
      if ($(this).data('checked')) {
        $(this).prop('checked', false)
        $(this).data('checked', false)
        postProductsBrand.fadeIn()
      } else {
        $('input[type="radio"][name="pet-filter"]').data('checked', false)
        $(this).data('checked', true)
      }
    })

    $('input[type="radio"][name="pet-filter"]').on('change', function() {
      var inputValue = $(this).val()
      $('.products-list .list > button').hide()
      postProductsBrand.each(function() {
        var brandProduct = $(this).attr('data-src-pet')
        if (inputValue === brandProduct) {
          $(this).fadeIn()
        } else {
          $(this).fadeOut()
        }
      })
    })

    if (postProductsBrand.length <= currentProductsBrand) {
      buttonProductsBrand.css({
        display: 'none',
        background: 'white',
        border: 'none',
      })
    }

    buttonProductsBrand.on('click', function() {
      for (var e = currentProductsBrand; e < currentProductsBrand + 4; e++) {
        if (postProductsBrand.eq(e)) {
          postProductsBrand.eq(e).css('display', 'block')
        }
      }
      currentProductsBrand += 4
      if (currentProductsBrand >= postProductsBrand.length) {
        buttonProductsBrand.fadeOut()
      }
    })
  })
}
